import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { createURL } from '@jwp/ott-common/src/utils/urlFormatting';
import { useAppInfo } from '@jwp/ott-hooks-react/src/useAppInfo';

import styles from './Image.module.scss';

type Props = {
  className?: string;
  image?: string;
  onLoad?: () => void;
  alt?: string;
  width?: number;
  handleError?: () => void;
  portraitImg?: boolean;
};

const setWidth = (url: string, width: number) => {
  return createURL(url, { width });
};

const Image = ({ className, image, onLoad, alt = '', width = 640, handleError, portraitImg }: Props) => {
  const { portraitThumbnail, landscapeThumbnail } = useAppInfo();
  const placeHolderImage = portraitImg ? portraitThumbnail : landscapeThumbnail;
  const [src, setSrc] = useState(image ? setWidth(image, width) : placeHolderImage);
  const [isPlaceholder, setIsPlaceholder] = useState(!image);
  useEffect(() => {
    if (image) {
      setSrc(setWidth(image, width));
      setIsPlaceholder(false);
    } else {
      setSrc(placeHolderImage);
      setIsPlaceholder(true);
    }
  }, [image, width, placeHolderImage]);

  const handleLoad = () => {
    if (onLoad) { onLoad(); }
  };

  const handleImageError = () => {
    if (handleError) { handleError(); }
    setSrc(placeHolderImage);
    setIsPlaceholder(true);
  };

  if (!image) { return null; }

  return <img className={classNames(className, styles.image, { [styles.placeholder]: isPlaceholder })} src={src} onLoad={handleLoad} alt={alt} onError={handleImageError} />;
};

export default React.memo(Image);
